import { Kind, OperationTypeNode, type DocumentNode } from "graphql";

import withOptionMutations from "./withOptionMutations.graphql";

const mutationOperationNames = (document: DocumentNode): string[] =>
  document.definitions.flatMap((definition) =>
    definition.kind === Kind.OPERATION_DEFINITION &&
    definition.operation === OperationTypeNode.MUTATION &&
    definition.name
      ? [definition.name.value]
      : []
  );

/** The `*WithOption` twins: every write that lands in a design option. */
export const OPTION_TWIN_MUTATIONS: ReadonlySet<string> = new Set(
  mutationOperationNames(withOptionMutations as DocumentNode)
);
